'use strict';

angular.module('schoolLinqApp').directive('limitTo', [
	function () {
		return {
			restrict: 'A',
			link: function (scope, elem, attrs) {
				var limit = parseFloat(attrs.limitTo);
				var originalvalue = 0;
				angular.element(elem).on('keypress', function (e) {
					//console.log(angular.element(elem).val());
					if (elem.val() <= limit) {
						originalvalue = elem.val();
					}
				});
				angular.element(elem).on('keyup', function (e) {
					if (elem.val() > limit) {
						elem.val(originalvalue);
						e.preventDefault();
					}
				});
			},
		};
	},
]);
